import { Link } from "react-router-dom";
import { FiArrowUpRight } from "react-icons/fi";

export default function Footer() {
  return (
    <footer className="px-5 pb-6 sm:px-6 md:px-10 lg:px-16">
      <div className="glass-card mx-auto max-w-7xl rounded-[32px] p-6 md:p-10">
        <div className="grid gap-10 md:grid-cols-[1.35fr_1fr]">
          <div>
            <p className="eyebrow">Code7s</p>
            <h2 className="mt-4 max-w-3xl text-3xl font-extrabold leading-tight tracking-tight text-neutral-950 md:text-5xl">
              Design the product. Build the platform. Launch the idea.
            </h2>
            <p className="mt-5 max-w-xl leading-7 text-neutral-600">
              A studio platform for startups, founders, and Code7s published
              apps. We help ideas move from concept to real products.
            </p>
            <Link
              to="/contact"
              className="mt-8 inline-flex items-center gap-2 rounded-full bg-neutral-950 px-5 py-3 text-sm font-bold text-white transition hover:-translate-y-0.5 hover:bg-neutral-800"
            >
              Start with Code7s
              <FiArrowUpRight aria-hidden="true" />
            </Link>
          </div>

          <div className="grid grid-cols-2 gap-8 text-sm">
            <div>
              <p className="mb-4 font-bold text-neutral-500">Studio</p>
              <div className="flex flex-col gap-3 font-semibold text-neutral-700">
                <Link to="/services">Services</Link>
                <Link to="/portfolio">Work</Link>
                <Link to="/about">About</Link>
                <Link to="/contact">Contact</Link>
              </div>
            </div>
            <div>
              <p className="mb-4 font-bold text-neutral-500">Products</p>
              <div className="flex flex-col gap-3 font-semibold text-neutral-700">
                <Link to="/products/spendnote">SpendNote</Link>
                <Link to="/products/scora">Scora</Link>
                <Link to="/products/gridlock">Grid Lock</Link>
                <Link to="/products/tools">Studio Tools</Link>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-10 border-t border-neutral-950/10 pt-5 text-center text-xs font-bold uppercase tracking-[0.2em] text-neutral-500">
          <Link to="/privacy-policy" className="transition hover:text-neutral-950">
            Privacy Policy
          </Link>
          <span className="mx-3">•</span>
          © 2026 Code7s. Startup product studio and app publisher.
        </div>
      </div>
    </footer>
  );
}
